// extracted by mini-css-extract-plugin
export default {"maincontainer":"StmAutoSuggestOrders_maincontainer__p7XOY","background":"StmAutoSuggestOrders_background__-gNxX","loader":"StmAutoSuggestOrders_loader__6ZP8Z"};